const joinExistingValues = (
  values: any[],
  separator = '',
  defaultValue: string | undefined | null = '',
) => {
  return values.filter((v) => !!v).join(separator) || (defaultValue ?? '');
};

export { joinExistingValues };
